/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AdminPlanDetailResponse } from '../model';
// @ts-ignore
import { AdminPlanResponse } from '../model';
// @ts-ignore
import { CreateEmptyMenuRequest } from '../model';
// @ts-ignore
import { CreateMenuRequest } from '../model';
// @ts-ignore
import { CreatePlanRequest } from '../model';
// @ts-ignore
import { MenuBriefResponse } from '../model';
// @ts-ignore
import { MenuResponse } from '../model';
// @ts-ignore
import { PlanBriefResponse } from '../model';
// @ts-ignore
import { PlanOptionBriefResponse } from '../model';
// @ts-ignore
import { UpdatePlanRequest } from '../model';
/**
 * AdminPlanControllerApi - axios parameter creator
 * @export
 */
export const AdminPlanControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} planId 
         * @param {CreateEmptyMenuRequest} createEmptyMenuRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMenu: async (planId: string, createEmptyMenuRequest: CreateEmptyMenuRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('createMenu', 'planId', planId)
            // verify required parameter 'createEmptyMenuRequest' is not null or undefined
            assertParamExists('createMenu', 'createEmptyMenuRequest', createEmptyMenuRequest)
            const localVarPath = `/admin/plans/{planId}/menus`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmptyMenuRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<CreateMenuRequest>} createMenuRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMenusWithMeals: async (createMenuRequest: Array<CreateMenuRequest>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMenuRequest' is not null or undefined
            assertParamExists('createMenusWithMeals', 'createMenuRequest', createMenuRequest)
            const localVarPath = `/admin/plans/menus-with-meals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMenuRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePlanRequest} createPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlan: async (createPlanRequest: CreatePlanRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPlanRequest' is not null or undefined
            assertParamExists('createPlan', 'createPlanRequest', createPlanRequest)
            const localVarPath = `/admin/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPlanRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlan: async (planId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('deletePlan', 'planId', planId)
            const localVarPath = `/admin/plans/{planId}`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanById: async (planId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('getPlanById', 'planId', planId)
            const localVarPath = `/admin/plans/{planId}`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBriefPlanOptions: async (planId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('listBriefPlanOptions', 'planId', planId)
            const localVarPath = `/admin/plans/{planId}/options/brief`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBriefPlans: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/plans/brief`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMenus: async (date: string, planId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('listMenus', 'date', date)
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('listMenus', 'planId', planId)
            const localVarPath = `/admin/plans/{planId}/menus`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMenusBetween: async (startDate: string, endDate: string, planId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('listMenusBetween', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('listMenusBetween', 'endDate', endDate)
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('listMenusBetween', 'planId', planId)
            const localVarPath = `/admin/plans/{planId}/menus/between`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlans: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planId 
         * @param {UpdatePlanRequest} updatePlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlan: async (planId: string, updatePlanRequest: UpdatePlanRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('updatePlan', 'planId', planId)
            // verify required parameter 'updatePlanRequest' is not null or undefined
            assertParamExists('updatePlan', 'updatePlanRequest', updatePlanRequest)
            const localVarPath = `/admin/plans/{planId}`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePlanRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPlanControllerApi - functional programming interface
 * @export
 */
export const AdminPlanControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPlanControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} planId 
         * @param {CreateEmptyMenuRequest} createEmptyMenuRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMenu(planId: string, createEmptyMenuRequest: CreateEmptyMenuRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MenuResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMenu(planId, createEmptyMenuRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<CreateMenuRequest>} createMenuRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMenusWithMeals(createMenuRequest: Array<CreateMenuRequest>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMenusWithMeals(createMenuRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreatePlanRequest} createPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPlan(createPlanRequest: CreatePlanRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPlan(createPlanRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePlan(planId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePlan(planId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanById(planId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPlanDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanById(planId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBriefPlanOptions(planId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanOptionBriefResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBriefPlanOptions(planId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBriefPlans(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanBriefResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBriefPlans(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} date 
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMenus(date: string, planId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MenuResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMenus(date, planId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMenusBetween(startDate: string, endDate: string, planId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MenuBriefResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMenusBetween(startDate, endDate, planId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPlans(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminPlanResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPlans(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} planId 
         * @param {UpdatePlanRequest} updatePlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePlan(planId: string, updatePlanRequest: UpdatePlanRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlan(planId, updatePlanRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminPlanControllerApi - factory interface
 * @export
 */
export const AdminPlanControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPlanControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} planId 
         * @param {CreateEmptyMenuRequest} createEmptyMenuRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMenu(planId: string, createEmptyMenuRequest: CreateEmptyMenuRequest, options?: any): AxiosPromise<MenuResponse> {
            return localVarFp.createMenu(planId, createEmptyMenuRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<CreateMenuRequest>} createMenuRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMenusWithMeals(createMenuRequest: Array<CreateMenuRequest>, options?: any): AxiosPromise<void> {
            return localVarFp.createMenusWithMeals(createMenuRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePlanRequest} createPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlan(createPlanRequest: CreatePlanRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createPlan(createPlanRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlan(planId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePlan(planId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanById(planId: string, options?: any): AxiosPromise<AdminPlanDetailResponse> {
            return localVarFp.getPlanById(planId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBriefPlanOptions(planId: string, options?: any): AxiosPromise<Array<PlanOptionBriefResponse>> {
            return localVarFp.listBriefPlanOptions(planId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBriefPlans(options?: any): AxiosPromise<Array<PlanBriefResponse>> {
            return localVarFp.listBriefPlans(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} date 
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMenus(date: string, planId: string, options?: any): AxiosPromise<MenuResponse> {
            return localVarFp.listMenus(date, planId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMenusBetween(startDate: string, endDate: string, planId: string, options?: any): AxiosPromise<Array<MenuBriefResponse>> {
            return localVarFp.listMenusBetween(startDate, endDate, planId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlans(options?: any): AxiosPromise<Array<AdminPlanResponse>> {
            return localVarFp.listPlans(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planId 
         * @param {UpdatePlanRequest} updatePlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlan(planId: string, updatePlanRequest: UpdatePlanRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updatePlan(planId, updatePlanRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminPlanControllerApi - object-oriented interface
 * @export
 * @class AdminPlanControllerApi
 * @extends {BaseAPI}
 */
export class AdminPlanControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} planId 
     * @param {CreateEmptyMenuRequest} createEmptyMenuRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPlanControllerApi
     */
    public createMenu(planId: string, createEmptyMenuRequest: CreateEmptyMenuRequest, options?: AxiosRequestConfig) {
        return AdminPlanControllerApiFp(this.configuration).createMenu(planId, createEmptyMenuRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<CreateMenuRequest>} createMenuRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPlanControllerApi
     */
    public createMenusWithMeals(createMenuRequest: Array<CreateMenuRequest>, options?: AxiosRequestConfig) {
        return AdminPlanControllerApiFp(this.configuration).createMenusWithMeals(createMenuRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePlanRequest} createPlanRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPlanControllerApi
     */
    public createPlan(createPlanRequest: CreatePlanRequest, options?: AxiosRequestConfig) {
        return AdminPlanControllerApiFp(this.configuration).createPlan(createPlanRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPlanControllerApi
     */
    public deletePlan(planId: string, options?: AxiosRequestConfig) {
        return AdminPlanControllerApiFp(this.configuration).deletePlan(planId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPlanControllerApi
     */
    public getPlanById(planId: string, options?: AxiosRequestConfig) {
        return AdminPlanControllerApiFp(this.configuration).getPlanById(planId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPlanControllerApi
     */
    public listBriefPlanOptions(planId: string, options?: AxiosRequestConfig) {
        return AdminPlanControllerApiFp(this.configuration).listBriefPlanOptions(planId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPlanControllerApi
     */
    public listBriefPlans(options?: AxiosRequestConfig) {
        return AdminPlanControllerApiFp(this.configuration).listBriefPlans(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} date 
     * @param {string} planId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPlanControllerApi
     */
    public listMenus(date: string, planId: string, options?: AxiosRequestConfig) {
        return AdminPlanControllerApiFp(this.configuration).listMenus(date, planId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {string} planId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPlanControllerApi
     */
    public listMenusBetween(startDate: string, endDate: string, planId: string, options?: AxiosRequestConfig) {
        return AdminPlanControllerApiFp(this.configuration).listMenusBetween(startDate, endDate, planId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPlanControllerApi
     */
    public listPlans(options?: AxiosRequestConfig) {
        return AdminPlanControllerApiFp(this.configuration).listPlans(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planId 
     * @param {UpdatePlanRequest} updatePlanRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPlanControllerApi
     */
    public updatePlan(planId: string, updatePlanRequest: UpdatePlanRequest, options?: AxiosRequestConfig) {
        return AdminPlanControllerApiFp(this.configuration).updatePlan(planId, updatePlanRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

